<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div>
    <br />
    <div class='titleContainer'>
      <h2 class='header'>Asset Register Categories</h2>
    </div>
    <br />

    <div class="row content-block">
      <div class="col">
        <table class='table table-bordered table-hover' >
          <thead class='thead-light'>
            <tr>
              <th>Category</th>
              <th>Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (cat of this.categories; track cat) {
              <tr>
                @if (cat.addToggle) {
                  <td>
                    <label>Category Name</label>
                    <input type='text' [(ngModel)]='cat.name' class='form-control'/>
                  </td>
                  <td>
                    <label>Category Type</label>
                    <input type='text' [(ngModel)]='cat.entity' class='form-control'/>
                  </td>
                  <td>
                    <button class='btn btn-success' (click)='saveRow()'>Save</button>
                  </td>
                }
                @if (!cat.addToggle) {
                  <td>{{cat.name}}</td>
                  <td colspan='2'>{{cat.entity}}</td>
                  <!-- <td class='p-0 text-center'>
                  <button
                    *ngIf='!this.disableButtons'
                    class='btn btn-warning m-0 btn-block'
                    (click)='this.editCategory(cat.id)'>
                    <i class="far fa-edit"></i>
                  </button>
                  <button
                    *ngIf='this.disableButtons'
                    class='btn btn-warning m-0 btn-block disabled'>
                    <i class="far fa-edit"></i>
                  </button>
                </td> -->
              }
            </tr>
          }
          <tr>
            <td colspan='3'>
              @if (!disableButtons) {
                <button class='btn btn-secondary' (click)='addRow()'><i class="fas fa-plus"></i> New</button>
              }
              @if (disableButtons) {
                <button class='btn btn-secondary' disabled><i class="fas fa-plus"></i> New</button>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
